import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Title,
  Text,
  Card,
  Stack,
  Button,
  Center,
  Grid,
  ThemeIcon,
  Box,
  Image
} from '@mantine/core';
import {
  IconFileImport,
  IconTools
} from '@tabler/icons-react';

const LandingPage = () => {
  const navigate = useNavigate();

  // Icon mapping for different tools
  const toolIcons = {
    ddwImport: IconFileImport,
    tools: IconTools
  };

  // Define the main options
  const options = {
    ddwImport: {
      name: "DDW Import",
      description: "Import and process DDW files with smart token parsing",
      route: "/ddd-import"
    },
    tools: {
      name: "Tools",
      description: "Access various Five9 utility tools with SOAP authentication",
      route: "/tools"
    }
  };

  const handleOptionSelect = (optionKey) => {
    console.log("Selected option:", optionKey);
    navigate(options[optionKey].route);
  };

  return (
    <Box
      style={{
        minHeight: '80vh',
        background: 'linear-gradient(135deg, #2e7d32 0%, #e8f5e8 100%)',
        padding: '40px 20px',
        borderRadius: '16px'
      }}
    >
      <Container size="lg">
        <Center>
          <Stack align="center" gap="xl" style={{ maxWidth: '1000px' }}>
            {/* Header Section */}
            <Stack align="center" gap="md">
              <Title
                order={1}
                size="2.5rem"
                fw={700}
                style={{ color: 'white', textAlign: 'center' }}
              >
                Five9 Automation Hub
              </Title>
              <Text
                size="xl"
                style={{ color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center' }}
              >
                Choose the automation tool you would like to use
              </Text>
            </Stack>

            {/* Tools Selection Grid */}
            <Grid gutter="xl" style={{ width: '100%', maxWidth: '800px' }}>
              {Object.keys(options).map((key) => {
                const option = options[key];
                const IconComponent = toolIcons[key] || IconTools;

                return (
                  <Grid.Col key={key} span={{ base: 12, sm: 6 }}>
                    <Card
                      shadow="xl"
                      padding="xl"
                      radius="md"
                      style={{
                        background: 'white',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        height: '320px',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-8px)';
                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.2)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                      }}
                      onClick={() => handleOptionSelect(key)}
                    >
                      <Stack align="center" gap="md" style={{ flex: 1 }}>
                        <ThemeIcon
                          size={80}
                          radius="md"
                          color="green"
                          variant="light"
                        >
                          <IconComponent size={48} />
                        </ThemeIcon>

                        <Title order={3} size="1.3rem" fw={600} align="center">
                          {option.name}
                        </Title>

                        <Text
                          size="sm"
                          color="dimmed"
                          align="center"
                          style={{ lineHeight: 1.5, flex: 1 }}
                        >
                          {option.description}
                        </Text>

                        <Button
                          color="green"
                          size="md"
                          radius="md"
                          fullWidth
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOptionSelect(key);
                          }}
                          style={{ fontWeight: 600 }}
                        >
                          Select {option.name}
                        </Button>
                      </Stack>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>

            {/* Footer Info */}
            <Stack align="center" gap="xs" style={{ marginTop: '40px' }}>
              <Text
                size="sm"
                style={{ color: 'rgba(255, 255, 255, 0.7)', textAlign: 'center' }}
              >
                Professional Five9 contact center configuration and automation tools
              </Text>
              <Text
                size="xs"
                style={{ color: 'rgba(255, 255, 255, 0.5)', textAlign: 'center' }}
              >
                Presidio Networked Solutions, Inc.
              </Text>
            </Stack>
          </Stack>
        </Center>
      </Container>
    </Box>
  );
};

export default LandingPage;
